import { gql, useQuery } from '@apollo/client';
import { Money } from '../types/gql';
import { Balances as Query } from './useBalance.types';

const query = gql`
  query Balances {
    currentUser {
      id
      balances {
        amount {
          value
          currency {
            code
          }
        }
      }
    }
  }
`;

interface PartialMoneyV2 {
  value: string;
  currency: { code: string };
}

function mapMoneyV2ToMoney(amount: PartialMoneyV2): Money {
  return {
    value: +amount.value,
    currency: amount.currency.code,
  };
}

export const useBalance = (currency: string) => {
  const { data, loading, error } = useQuery<Query>(query);
  const result = data?.currentUser?.balances?.find(
    ({ amount }) => amount?.currency.code === currency
  );

  return {
    loading,
    error,
    balance: mapMoneyV2ToMoney(result?.amount || { value: '0', currency: { code: currency } }),
  };
};
